/* eRamis - sertarul de pe telefon, refacut ca foaie care urca de jos.
   NU atinge sections/eramis-header.liquid: ii rescrie doar continutul la runtime,
   exact tehnica pe care o foloseste deja eramis-mega-menu.liquid.
   Deschiderea/inchiderea raman ale temei (eramis-custom.js pune .is-open pe
   #erMobileMenu); aici doar oglindim starea pe <body> ca sa putem anima valul
   si X-ul, care stau in afara foii.
   Datele vin din snippets/eramis-nav-data.liquid (window.ER_NAV) pentru ca
   fisierele din assets/ nu trec prin Liquid. */
(function(){
  'use strict';

  var CHEV = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  function esc(s){
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c];
    });
  }

  function thumb(cat){
    if(cat.img){
      return '<img class="ersheet-thumb" src="' + esc(cat.img) + '" width="62" height="62" loading="lazy" alt="">';
    }
    return '<span class="ersheet-thumb" aria-hidden="true">' + esc(String(cat.title).slice(0,1)) + '</span>';
  }

  function buildList(nav){
    var ul = document.createElement('ul');
    ul.className = 'ersheet';

    nav.cats.forEach(function(cat){
      var li = document.createElement('li');
      li.className = 'ersheet-li' + (cat.bts ? ' ersheet-li--bts' : '');
      var hasKids = cat.kids && cat.kids.length;

      var row = '<div class="ersheet-row">' +
        '<a class="ersheet-cat" href="' + esc(cat.url) + '">' + thumb(cat) +
        '<span class="ersheet-name">' + esc(cat.title) + '</span></a>';
      if(hasKids){
        row += '<button type="button" class="ersheet-tgl" aria-expanded="false" aria-label="Deschide ' + esc(cat.title) + '">' + CHEV + '</button>';
      }
      row += '</div>';

      if(hasKids){
        row += '<ul class="ersheet-sub">' + cat.kids.map(function(k){
          return '<li><a href="' + esc(k.url) + '">' + esc(k.title) + '</a></li>';
        }).join('') + '</ul>';
      }
      li.innerHTML = row;
      ul.appendChild(li);
    });

    /* butonul de deschidere nu e <a>, deci nu declanseaza inchiderea automata
       pe care eramis-custom.js o pune pe orice link din sertar */
    ul.addEventListener('click', function(e){
      var btn = e.target.closest('.ersheet-tgl');
      if(!btn){ return; }
      var li = btn.closest('.ersheet-li');
      var open = li.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(typeof window.erSheetMeasure === 'function'){ window.erSheetMeasure(); }
    });

    return ul;
  }

  function buildTail(nav){
    var frag = document.createDocumentFragment();

    if(nav.links && nav.links.length){
      var mini = document.createElement('ul');
      mini.className = 'ersheet-mini';
      mini.innerHTML = nav.links.map(function(l){
        return '<li><a href="' + esc(l.url) + '">' + esc(l.title) + '</a></li>';
      }).join('');
      frag.appendChild(mini);
    }

    var soc = (nav.social || []).filter(Boolean);
    if(soc.length){
      var box = document.createElement('div');
      box.className = 'ersheet-social';
      box.innerHTML = soc.map(function(s){
        return '<a href="' + esc(s.u) + '" target="_blank" rel="noopener">' + esc(s.n) + '</a>';
      }).join('');
      frag.appendChild(box);
    }

    if(nav.account){
      var foot = document.createElement('div');
      foot.className = 'ersheet-foot';
      /* Steagul si "RO" sunt DECORATIVE, ca la referinta. Nu sunt link si nu au sageata,
         tocmai ca sa nu promita un selector de tara care nu exista: schimbarea reala de
         piata/limba tine de setarile Shopify, nu de tema. */
      foot.innerHTML = '<span class="ersheet-loc"><span class="ersheet-flag" aria-hidden="true"></span>RO</span>' +
                       '<a href="' + esc(nav.account.url) + '">' + esc(nav.account.label) + '</a>';
      frag.appendChild(foot);
    }

    return frag;
  }

  function boot(){
    var menu = document.getElementById('erMobileMenu');
    var nav = window.ER_NAV;
    if(!menu || !nav || !nav.cats || menu.dataset.erSheet === '1'){ return; }
    menu.dataset.erSheet = '1';

    /* lista veche poate fi cea din header sau cea rescrisa de mega meniu */
    var old = menu.querySelector('ul');
    if(old){ old.parentNode.removeChild(old); }
    menu.appendChild(buildList(nav));
    menu.appendChild(buildTail(nav));

    /* X-ul iese din foaie ca sa poata pluti deasupra ei; listenerul de inchidere
       e deja legat pe element de eramis-custom.js si supravietuieste mutarii */
    var x = menu.querySelector('.er-mobile-menu-close');
    if(x){
      x.classList.add('ersheet-x');
      document.body.appendChild(x);
    }

    var veil = document.createElement('div');
    veil.className = 'ersheet-veil';
    veil.addEventListener('click', function(){
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
    document.body.appendChild(veil);

    /* Foaia isi ia inaltimea din continut, deci X-ul nu poate fi asezat deasupra ei
       dintr-o valoare fixa. Scriem inaltimea reala intr-o variabila CSS. */
    function measure(){
      document.documentElement.style.setProperty('--ersheet-h', menu.offsetHeight + 'px');
    }
    window.erSheetMeasure = measure;

    function sync(){
      document.body.classList.toggle('er-sheet-open', menu.classList.contains('is-open'));
      measure();
    }
    measure();
    sync();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    if(window.MutationObserver){
      new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && menu.classList.contains('is-open')){
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* mega meniul isi rescrie lista tot pe DOMContentLoaded si e randat inaintea
     noastra, deci listenerul lui se executa primul - noi venim peste */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
